import { render, staticRenderFns } from "./SelfServiceLanding.vue?vue&type=template&id=ba0fd238&scoped=true&"
import script from "./SelfServiceLanding.vue?vue&type=script&lang=js&"
export * from "./SelfServiceLanding.vue?vue&type=script&lang=js&"
import style0 from "./SelfServiceLanding.vue?vue&type=style&index=0&id=ba0fd238&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ba0fd238",
  null
  
)

export default component.exports